import React from 'react'
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons'

const pageItems = (page, totalPages) => {
  const pages = new Set([1, totalPages, page - 1, page, page + 1].filter(p => p >= 1 && p <= totalPages))
  const sorted = [...pages].sort((a, b) => a - b)
  return sorted.reduce((items, p, index) => {
    if (index > 0 && p - sorted[index - 1] > 1) items.push(p - sorted[index - 1] === 2 ? p - 1 : `gap-${p}`)
    items.push(p)
    return items
  }, [])
}

const baseButton = 'h-8 min-w-[2rem] px-2 rounded-lg text-sm font-semibold flex items-center justify-center transition-colors'
const idleButton = 'text-rb-black dark:text-white hover:bg-gray-100 dark:hover:bg-rb-dark-mode-lighter disabled:opacity-40 disabled:hover:bg-transparent'

export default function Pagination({ page, totalPages, totalCount, perPage, onChange, itemLabel = 'items' }) {
  if (!totalCount) return null

  const from = (page - 1) * perPage + 1
  const to = Math.min(page * perPage, totalCount)

  return (
    <div className="flex items-center justify-between gap-4 py-3">
      <p className="text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey">
        Showing <span className="font-semibold text-rb-black dark:text-white">{from.toLocaleString()}–{to.toLocaleString()}</span> of <span className="font-semibold text-rb-black dark:text-white">{totalCount.toLocaleString()}</span> {itemLabel}
      </p>
      {totalPages > 1 && (
        <nav className="flex items-center gap-1" aria-label="Pagination">
          <button type="button" aria-label="Previous page" disabled={page <= 1} onClick={() => onChange(page - 1)} className={`${baseButton} ${idleButton}`}>
            <ChevronLeft />
          </button>
          {pageItems(page, totalPages).map(item => (
            typeof item === 'string'
              ? <span key={item} className="px-1 text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey">…</span>
              : (
                <button
                  key={item}
                  type="button"
                  aria-current={item === page ? 'page' : undefined}
                  onClick={() => item !== page && onChange(item)}
                  className={`${baseButton} ${item === page ? 'bg-rb-green text-white dark:text-rb-dark-mode' : idleButton}`}
                >
                  {item}
                </button>
              )
          ))}
          <button type="button" aria-label="Next page" disabled={page >= totalPages} onClick={() => onChange(page + 1)} className={`${baseButton} ${idleButton}`}>
            <ChevronRight />
          </button>
        </nav>
      )}
    </div>
  )
}
